import { render, staticRenderFns } from "./LeftWrap3.vue?vue&type=template&id=3da9b1be&scoped=true"
import script from "./LeftWrap3.vue?vue&type=script&lang=js"
export * from "./LeftWrap3.vue?vue&type=script&lang=js"
import style0 from "./LeftWrap3.vue?vue&type=style&index=0&id=3da9b1be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9b1be",
  null
  
)

export default component.exports